// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"survey-banner_wrapper__2isio","title":"survey-banner_title__2K-Se","progressWrapper":"survey-banner_progressWrapper__2swRV","progress":"survey-banner_progress__1xNEk"};